import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../constants/common'
import Button from '../../../../Button'
import { FileUpload } from '../../../../File'
import {
  ICON_COLOR,
  ICON_HEIGHT_54,
  ICON_HEIGHT_72,
  IconNG,
  IconSpinnerOverlay,
} from '../../../../Icon'
import {
  PdfViewer,
  PdfViewerFitMode,
  PdfViewerNavigation,
} from '../../../../PdfViewer'
import Text from '../../../../Text'
import { QA_NAME_INVOICE_MODAL_UPLOAD_FILE_BTN } from '../../../InvoiceModal.constants'
import { INVOICE_FILE_UPLOAD_OPTIONS } from '../FormFields.constants'

import * as styles from './FormFieldsPreview.module.css'

import UploadIcon from '../../../../../icons/attach.svg'
import InvoiceIcon from '../../../../../icons/invoice.svg'

function FormFieldsPreview({
  isPdfLoading,
  isUploadDisabled,
  isUploading,
  pdfFile,
  withFileUpload,
  onFinishUpload,
  onStartUpload,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.previewPanel}>
      {isPdfLoading || isUploading ? (
        <IconSpinnerOverlay
          className={styles.loader}
          color={ICON_COLOR.SecondaryTextColor}
          size={ICON_HEIGHT_54}
        />
      ) : null}
      {pdfFile && !isUploading ? (
        <PdfViewer
          singlePage
          Navigation={PdfViewerNavigation}
          className={styles.pdfViewer}
          file={pdfFile}
          fitMode={PdfViewerFitMode.PageFit}
          navigationProps={{
            arrowButtonProps: { isGrey: true },
            buttonClassName: styles.navButton,
            leftButtonClassName: styles.navButtonLeft,
            rightButtonClassName: styles.navButtonRight,
          }}
          tools={EMPTY_LIST}
        />
      ) : null}
      {withFileUpload && !pdfFile && !isPdfLoading && !isUploading ? (
        <div className={styles.uploadPlaceholder}>
          <IconNG
            Icon={InvoiceIcon}
            color={ICON_COLOR.SecondaryTextColor50}
            size={ICON_HEIGHT_72}
          />
          <Text className={styles.uploadPlaceholderText}>
            {t('BudgetPlan.NoInvoiceAvailableKey')}
          </Text>
          <FileUpload
            className={styles.uploadButtonWrapper}
            disabled={isUploadDisabled}
            options={INVOICE_FILE_UPLOAD_OPTIONS}
            onFinishUpload={onFinishUpload}
            onStartUpload={onStartUpload}
          >
            <Button.Contained
              beforeIconProps={{ Icon: UploadIcon }}
              disabled={isUploadDisabled}
              qaName={QA_NAME_INVOICE_MODAL_UPLOAD_FILE_BTN}
              text={t('BudgetPlan.UploadInvoiceKey')}
            />
          </FileUpload>
        </div>
      ) : null}
    </div>
  )
}

export default FormFieldsPreview
